<template>
  <section class="p-2">
    <v-card>
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">
          Branch Setup -{{ partnerBranchDetails.branch_code }}
        </div>
        <div>
          <bread-crumb :bread-crumbs="['Branch Summary', 'Branch Setup']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pt-4 ma-0">
        <v-form ref="form" v-model="valid">
          <v-card class="pb-3">
            <v-sheet
              class="v-sheet--offset ms-4 pt-1 text-center"
              elevation="2"
              width="170px"
            >
              <p class="font-weight-bold">
                <v-icon small class="me-1">mdi-office-building-outline</v-icon
                >BRANCH SETUP
              </p>
            </v-sheet>

            <v-row class="ms-1 me-1 mt-1">
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="required labelFontsize my-0"> Branch Name </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Branch Name"
                  :rules="FullnameValidations"
                  v-model="partnerBranchDetails.branch_name"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">Branch Code</label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Branch code"
                  v-model="partnerBranchDetails.branch_code"
                  :disabled="branchDisplay"
                ></v-text-field>
              </v-col> -->
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">Alpha code</label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Alpha code"
                  v-model="partnerBranchDetails.alpha_code"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Country </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="Country"
                  :disabled="$route.query.country_cd ? true : false"
                  :items="dropdown.countryOptions"
                  item-text="text"
                  item-value="value"
                  v-model="partnerBranchDetails.country"
                  @change="getStates()"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> State </label>
                <v-autocomplete
                  class="rounded"
                  dense
                  outlined
                  placeholder="State"
                  :items="dropdown.state_options"
                  v-model="partnerBranchDetails.state"
                  @change="getCities(true)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> City </label>
                <v-autocomplete
                  v-if="!cityInputEnabled"
                  class="rounded"
                  dense
                  outlined
                  placeholder="City"
                  :items="dropdown.city_options"
                  v-model="partnerBranchDetails.city"
                ></v-autocomplete>
                <v-text-field
                  v-else
                  class="rounded"
                  dense
                  outlined
                  placeholder="Enter City"
                  v-model="partnerBranchDetails.city"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">Postal Code </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Postal Code"
                  v-model="partnerBranchDetails.zip_code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Address </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Address"
                  v-model="partnerBranchDetails.address"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Email </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  placeholder="Email"
                  :rules="
                    partnerBranchDetails.email ? branchemailValidations : []
                  "
                  v-model="partnerBranchDetails.email"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Mobile </label>
                <vue-phone-number-input
                  :default-country-code="contact_person_phone_cty_code"
                  v-model="partnerBranchDetails.mobile_number"
                  @update="onChangeNumber"
                  class="z-index"
                />
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0">
                  Send Transaction From
                </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  v-model="partnerBranchDetails.send_transaction_from"
                  type="time"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Send Transaction To </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="time"
                  v-model="partnerBranchDetails.send_transaction_to"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Pay Transaction From </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="time"
                  v-model="partnerBranchDetails.pay_transaction_from"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" lg="4" xs="12">
                <label class="labelFontsize my-0"> Pay Transaction To </label>
                <v-text-field
                  class="rounded"
                  dense
                  outlined
                  type="time"
                  v-model="partnerBranchDetails.pay_transaction_to"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2" lg="2" xs="12">
                <v-checkbox
                  label="Is API Partner"
                  class="mt-5"
                  v-model="partnerBranchDetails.is_api_partner"
                />
              </v-col>
              <v-col cols="12" md="2" lg="2" xs="12">
                <v-checkbox
                  label="Is Head Office"
                  class="mt-5"
                  v-model="partnerBranchDetails.is_head_office"
                />
              </v-col>
            </v-row>
          </v-card>
        </v-form>
      </v-card-text>
      <v-divider class="mb-0 pa-0"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" small @click="onSubmitFor">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import { Partnervalidations, BranchValidations } from "@/utils/validation";
import setupService from "@/services/SetupService/setupService";
import commonService from "@/services/CommonService/commonService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
export default {
  name: "Branch Setup",
  mixins: [alerts],
  data() {
    return {
      counter: 200,
      ...Partnervalidations,
      ...BranchValidations,
      valid: true,
      loader: false,
      branchDisplay: false,
      agentTypes: [],
      natureofBusiness: [],
      contact_error1: false,
      contact_person_phone_cty_code: "MY",
      isValidNumber1: false,
      cityInputEnabled: false,
      dropdown: {
        countryOptions: [],
        state_options: [],
        city_options: [],
        country_objs: [],
      },
      partnerBranchDetails: {
        send_transaction_from: null,
        send_transaction_to: null,
        pay_transaction_from: null,
        pay_transaction_to: null,
        branch_name: null,
        branch_code: null,
        partner_id: null,
        alpha_code: null,
        settlement_currency: null,
        address: null,
        country: null,
        state: null,
        city: null,
        zip_code: null,
        mobile_number: null,
        mobile_cty_code: null,
        email: null,
        is_head_office: true,
        is_api_partner: true,
      },
    };
  },
  components: {
    Loading,
    BreadCrumb,
    VuePhoneNumberInput,
  },
  watch: {
    "partnerBranchDetails.country"(val) {
      this.dropdown.country_objs.map((ele) => {
        if (ele.iso_alpha3 === val) {
          this.partnerBranchDetails.settlement_currency = ele.currency_code;
        }
      });
    },
  },
  mounted() {
    const id = this.$route.query.parent_partner_id;
    const branch_id = this.$route.query.branch_id;
    console.log("id", id, this.$route.params);
    this.getcountryList();
    this.getdropdowntypes("AGT");
    this.getdropdowntypes("NOB");
    if (branch_id && id) {
      this.getPartnerById(branch_id);
      this.branchDisplay = true;
    } else if (this.$route.query.country_cd) {
      this.partnerBranchDetails.country = this.$route.query.country_cd;
      this.getStates();
    }
  },
  methods: {
    onSubmitFor() {
      if (this.partnerBranchDetails.branch_id) {
        this.updateBranchData(this.partnerBranchDetails.branch_id);
      } else {
        this.saveBranchData();
      }
    },
    async getPartnerById(branch_id) {
      // const routerDataItem = this.$route.params.branch_id;
      if (branch_id) {
        try {
          const response = await partnerService.getBranchbyId(branch_id);
          if (response.status === 200) {
            this.partnerBranchDetails = response.data.data[0];
            this.partnerBranchDetails.country = this.$route.query.country_cd;
            this.getStates();
            console.log(this.partnerBranchDetails);
            if (this.partnerBranchDetails.partner_id) {
              this.contact_person_phone_cty_code =
                this.partnerBranchDetails.mobile_cty_code;
            } else {
              this.partnerBranchDetails.contact_person_phone_cty_code = "MY";
            }
          } else {
            this.showAlertError(
              "Fetch Partner Data Failed: ",
              response.data.message
            );
          }
        } catch (e) {
          this.showAlertError(
            "Fetch Partner Data Failed: Something went wrong"
          );
          console.log(e);
        }
      } else {
        console.log("partnerDetails");
      }
    },
    async saveBranchData() {
      const validate = this.$refs.form.validate();

      if (validate) {
        this.partnerBranchDetails.partner_id = parseInt(
          this.$route.query.parent_partner_id
        );
        try {
          const response = await partnerService.partnerAddBranch(
            this.partnerBranchDetails
          );
          console.log("response", response);
          if (response && response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            setTimeout(() => {
              this.$router.push({
                name: "Branch Summary",
                query: {
                  parent_partner_id: this.partnerBranchDetails.partner_id,
                  country_cd: this.$route.query.country_cd,
                },
              });
            }, 300);
          } else {
            this.showAlertError(`Save Branch: ${response.data.message}`);
          }
        } catch (e) {
          console.log("error branch", e);
          this.showAlertError("Failed Saved data : Something went wrong");
        }
      }
    },
    async updateBranchData(id) {
      const validate = this.$refs.form.validate();

      if (validate) {
        this.partnerBranchDetails.partner_id =
          this.$route.query.parent_partner_id;
        try {
          const response = await partnerService.partnerUpdateBranch(
            id,
            this.partnerBranchDetails
          );
          if (response.data.status_code == 200) {
            this.showAlertSuccess(response.data.message);
            setTimeout(() => {
              this.$router.push({
                name: "Branch Summary",
                query: {
                  parent_partner_id: this.partnerBranchDetails.partner_id,
                  country_cd: this.$route.query.country_cd,
                },
              });
            }, 300);
          } else {
            this.showAlertError("Failed" + response.data.message);
          }
        } catch (e) {
          console.log(e);
          this.showAlertError("Failed Update Data : Something went wrong");
        }
      }
    },
    onChangeNumber(e) {
      e ? (this.contact_error1 = false) : (this.contact_error1 = true);
      console.log("entry", e.nationalNumber);
      this.isValidNumber1 = e.isValid;
      this.partnerBranchDetails.mobile_number = e.nationalNumber;
      this.partnerBranchDetails.mobile_cty_code = e.countryCode;
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.dropdown.countryOptions = response.data.data.map((i) => {
            return { text: i.name, value: i.iso_alpha3 };
          });
          this.dropdown.country_objs = response.data.data;
        }
        if (this.partnerBranchDetails.country) {
          this.getStates();
        }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.dropdown.countryOptions = [];
      }
    },
    async getStates() {
      try {
        const response = await commonService.getStatesList(
          this.partnerBranchDetails.country
        );
        if (response.status === 200) {
          this.dropdown.state_options = response.data.data.map((i) => {
            return { text: i.name, value: i.state_code };
          });
          if (this.partnerBranchDetails.state) {
            const tempstore = this.partnerBranchDetails.state;
            this.partnerBranchDetails.state = tempstore;
            this.getCities();
          }
        } else {
          this.dropdown.state_options = [];
        }
        console.log("States", response);
      } catch (e) {
        this.dropdown.state_options = [];
        console.error(e);
      }
    },
    async getCities(resetSelection = false) {
      if (resetSelection) this.partnerBranchDetails.city = "";
      this.cityInputEnabled = false;
      this.dropdown.city_options = [];
      try {
        const response = await commonService.getCitiesList(
          this.partnerBranchDetails.country,
          this.partnerBranchDetails.state
        );
        console.log("cities", response);
        if (response.status === 200) {
          this.dropdown.city_options = response.data.data.map((i) => {
            return { text: i.name, value: i.name, id: i.id };
          });
          this.cityInputEnabled = this.dropdown.city_options.length === 0;
        } else {
          this.dropdown.city_options = [];
        }
        console.log("company_city", response);
      } catch (error) {
        this.dropdown.city_options = [];
        console.error("Error fetching :", error);
      }
    },
    async getdropdowntypes(code) {
      try {
        const response = await commonService.getparameterdropdowns(code);
        if (response.data.status_code === 200) {
          switch (code) {
            case "AGT":
              console.log("AGT codes", response.data.data);
              this.agentTypes = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "NOB":
              console.log("NOB codes", response.data.data);
              this.natureofBusiness = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
            case "ETD":
              console.log("ETD codes", response);
              this.entityType = response.data.data.map((i) => {
                return { text: i.value, value: i.value_code };
              });
              break;
          }
        }
      } catch (error) {
        console.error("Error fetching :", error);
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}

.danger {
  color: rgb(255 155 155);
  transition: 1s;
}

.v-sheet--offset {
  top: -14px;
  width: 200px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}

.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
</style>
